import React from 'react';
import { createRoot } from 'react-dom/client';
import { createStore } from 'redux';

import appReducer from './src/reducer.js';
import Root from './index.root'; // eslint-disable-line

// Create store
let store; // eslint-disable-line

if (process.env.NODE_ENV === 'development') {
  const devtools = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f;
  store = createStore(appReducer, devtools);
} else {
  store = createStore(appReducer);
}

// where to mount on page
const appElement = document.getElementById('app');
const root = createRoot(appElement);
root.render(<Root store={store} />);

export default store;
